module.exports = __webpack_public_path__ + "img/double-arrow-vertical-symbol.6ec9f63f.png";